import { create } from '@incodetech/welcome'
import { configClient } from '@egw/config'

interface Config {
  incode: {
    clientId: string
    sardineUrl: string
    consentId: string
  }
}

let incodeInstance: ReturnType<typeof create> | null = null

export const getIncodeClient = () => {
  if (incodeInstance) {
    return incodeInstance
  }

  const config = configClient.getConfig() as Config

  incodeInstance = create({
    clientId: config.incode.clientId,
    apiURL: config.incode.sardineUrl,
    theme: {},
  })
  return incodeInstance
}
